export default {"src":"/statics/ecommerce/_next/static/media/big-grey.b60ec6c7.svg","height":187,"width":391,"blurWidth":0,"blurHeight":0};